import { Card, CardContent } from 'components/ui/card'
import { cn } from 'lib/utils'


export function StatCard({ title, value, description, icon, trend, variant = 'default' }) {
  const variantStyles = {
    default: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    danger: 'bg-destructive/10 text-destructive',
  }

  return (
    <Card className="border border-border">
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-1">
            <span className="text-xs font-medium text-muted-foreground">{title}</span>
            <span className="text-2xl font-bold text-foreground tracking-tight">{value}</span>
            {description && (
              <span className="text-xs text-muted-foreground">{description}</span>
            )}
            {trend && (
              <span
                className={cn(
                  'text-xs font-medium',
                  trend.value >= 0 ? 'text-success' : 'text-destructive'
                )}
              >
                {trend.value >= 0 ? '+' : ''}
                {trend.value}% {trend.label}
              </span>
            )}
          </div>
          <div className={cn('flex size-10 items-center justify-center rounded-lg', variantStyles[variant])}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}